export default "__VITE_ASSET__b98cb42f__"